import { Component, OnInit } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-boarding-videos-list',
  templateUrl: './boarding-videos-list.component.html',
  styleUrls: ['./boarding-videos-list.component.css']
})
export class BoardingVideosListComponent implements OnInit {
  tutorialslist: any;
  type: any;
  sourceID: any;
  srcvideoId: any;
  destID: any;
  destvideoId: any;

  constructor(private apiService: ApiService, private toasterService: ToasterService, private route: ActivatedRoute, private router: Router,) { }

  ngOnInit() {
  }
  data: any = [{
    "modulename": "Staff",

  }, {
    "modulename": "Site",

  }, {
    "modulename": "Schedule",

  },
  {
    "modulename": "Watch",

  },
  {
    "modulename": "Timesheet",

  },];

  toggleAccordian(event, index, item) {
    this.tutorialdata = [];
    this.type =item.modulename;
    this.getvideosdata(item.modulename)
    const element = event.target;
    element.classList.toggle("active");
    if (this.data[index].isActive) {
      this.data[index].isActive = false;
    } else {
      this.data[index].isActive = true;
    }
    const panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }

  tutorialdata: any;
  getvideosdata(type) {
    this.tutorialslist = [];
    this.apiService.gettutorialData(type).subscribe((res: any) => {
      // this.tutorialdata = JSON.parse(res._body);
      this.tutorialdata =res;
      this.tutorialslist = this.tutorialdata.data;
      this.tutorialslist.sort((a, b) => {
        return a.order - b.order;
      });
    });
  }

  deletedata(id) {
    let data = {
      _id: id
    }
    this.apiService.deleteVideo(data).subscribe((res: any) => {
      // this.tutorialdata = JSON.parse(res._body);
      this.tutorialdata =res;
      this.toasterService.popAsync('Successfully done');
      this.ngOnInit();
    });
  }
  getTimeUnit(timeStr: string | number): string {
    const timeString = typeof timeStr === 'number' ? timeStr.toString() : timeStr;
    
    if (!timeString.includes('.')) {
      return "min";
    }

    const timeParts: string[] = timeString.split('.');
    if (timeParts.length !== 2) {
      return "Invalid time format";
    }

    return timeParts[0] === '0' ? "sec" : "min";
  }

  editdata(data) {
    this.router.navigate(['onboarding-tutorial', data]);
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  drag(ev) {
    this.sourceID = ev._id;
    this.srcvideoId = ev.order;

    // ev.dataTransfer.setData("text", ev.target.id);
  }

  drop(ev) {
    this.destID = ev._id;
    this.destvideoId = ev.order;
    // ev.preventDefault();
    let data ={
      type:ev.type,
      sourceOrderVideoId :this.sourceID,
      destinationOrderVideoId: this.destID,
      sourceOrder:this.srcvideoId,
      destinationOrder:this.destvideoId
    }
    this.apiService.updateorder(data).subscribe((res: any) => {
      this.getvideosdata(ev.type)
    },error => {
      this.toasterService.pop('error')
    });
  }
   

  dragnDrop(data){
    this.apiService.deleteVideo(data).subscribe((res: any) => {
      // this.tutorialdata = JSON.parse(res._body);
      // this.toasterService.pop('Successfully done');
      // this.ngOnInit();
    });
  }
  }
  





// WEBPACK FOOTER //
// ./src/app/components/boarding-videos-list/boarding-videos-list.component.ts